import { useEffect, useState } from "react";
import { ChefHat, CircleCheck, Clock3, Loader2, PackageCheck, SearchX } from "lucide-react";

type Status = { dailyNumber: string; type: string; kitchenState: string; status: string; fulfillmentState: string };
const STEPS = [
  { id: "pending", label: "Order received", icon: Clock3 }, { id: "preparing", label: "Being prepared", icon: ChefHat },
  { id: "ready", label: "Ready", icon: PackageCheck }, { id: "served", label: "Completed", icon: CircleCheck }
] as const;

/** Customer-facing page behind the receipt QR code. Shows the order number and progress only. */
export function PublicStatus({ token }: { token: string }) {
  const [status, setStatus] = useState<Status | null | undefined>(undefined);
  useEffect(() => {
    let active = true;
    const load = () => import("../backend/firebase").then(({ fetchPublicStatus }) => fetchPublicStatus(token)).then((value) => { if (active) setStatus(value); }).catch(() => { if (active) setStatus(null); });
    void load();
    const timer = setInterval(load, 20_000);
    return () => { active = false; clearInterval(timer); };
  }, [token]);
  const reached = status ? (status.status === "completed" ? 3 : STEPS.findIndex((step) => step.id === status.kitchenState)) : -1;
  return <div className="grid min-h-full place-items-center p-5">
    <div className="card w-full max-w-sm p-7 text-center">
      <p className="eyebrow mb-2">Mango Moons Restaurant</p>
      {status === undefined ? <Loader2 className="mx-auto my-10 animate-spin text-mango" size={30}/>
        : status === null ? <><SearchX className="mx-auto my-5 text-mute" size={36}/><h1 className="text-2xl">Order not found</h1><p className="mt-2 text-sm text-mute">This link may have expired. Please ask our staff for help.</p></>
        : status.status === "voided" ? <><h1 className="text-5xl">{status.dailyNumber}</h1><p className="mt-4 text-bad">This order was cancelled.</p></>
        : <><h1 className="text-6xl text-mango">{status.dailyNumber}</h1>
          <ol className="mt-7 space-y-2 text-left">{STEPS.map((step, index) => <li key={step.id} className={`flex items-center gap-3 rounded-xl border px-4 py-3 ${index <= reached ? "border-ok/40 bg-ok/10 text-cream" : "border-line text-faint"}`}>
            <step.icon size={20} className={index <= reached ? "text-ok" : ""}/><span className="font-medium">{step.label}</span></li>)}</ol></>}
    </div>
  </div>;
}
